/* de blinkie - keep sliders in step with the page width (30 Aug 2026)

   THE BUG THIS FIXES
   The Shop By Shape / Shop By Category sliders are Swiper carousels.
   Swiper measures its container once and gives every slide a fixed pixel
   width from that measurement. If the page's width changes after that -
   browser zoom, un-maximising then maximising the window, a scrollbar
   appearing - and Swiper misses it, the slides keep their stale widths.
   Stale-narrow slides pack against the LEFT edge and leave all the slack
   on the RIGHT, which reads as the whole page having more margin on the
   right than the left. Nothing is off-centre; the slides are simply the
   wrong size for their container.

   Verified live: container at 1780px, Swiper still holding widths computed
   for 1631px; tiles sat 89px from the left and 216px from the right.
   One swiper.update() made it 89 / 90.

   THE FIX - three layers, because no single signal catches every trigger
   (ResizeObserver, for one, does not fire for zoom-induced changes):
     1. ResizeObserver on each initialised Swiper container
     2. window resize listener
     3. a light watchdog every 600ms that compares each Swiper's cached
        width to its container's real width and updates only on mismatch -
        four elements, two property reads each; the cost is nothing.
   update() is idempotent, so none of this can fight Swiper's own resize
   handling. */
(function(){
  function swipers(){
    var out=[], els=document.querySelectorAll('.swiper, .swiper-container');
    for(var i=0;i<els.length;i++){ if(els[i].swiper) out.push(els[i]); }
    return out;
  }
  function sync(force){
    var els=swipers();
    for(var i=0;i<els.length;i++){
      var el=els[i], sw=el.swiper;
      try{
        if(force || Math.abs(el.clientWidth - sw.width) > 1) sw.update();
      }catch(e){}
    }
  }
  var t=null, lastW=0;
  function schedule(){ clearTimeout(t); t=setTimeout(function(){ sync(true); },150); }
  /* Only width changes matter to Swiper. Height changes (lazy images, the mobile
     address bar showing/hiding) used to force an update of every slider, which
     could interrupt a swipe in progress. */
  function onResize(){ var w=document.documentElement.clientWidth; if(w!==lastW){ lastW=w; schedule(); } }
  function boot(){
    if('ResizeObserver' in window){
      lastW=document.documentElement.clientWidth;
      var ro=new ResizeObserver(onResize);
      var els=swipers();
      for(var i=0;i<els.length;i++) ro.observe(els[i]);
      ro.observe(document.documentElement);
      setTimeout(function(){ var l=swipers(); for(var i=0;i<l.length;i++) ro.observe(l[i]); },2500);
    }
    window.addEventListener('resize',onResize);
    window.addEventListener('pageshow',function(e){ if(e.persisted) schedule(); });
    setInterval(function(){ sync(false); },600);
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',boot); } else { boot(); }
})();
